import Rails from "@rails/ujs"
import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['totalPoint', 'fee1', 'fee2', 'fee3', 'fee4', 'fee5', 'fee6', 'fee7', 'fee8', 'fee9', 'fee10', 'fee11','fee12','fee13','fee14','fee15','fee16','fee17','form', 'generateButton', 'paymentLink', 'paymentLinkError']
  static classes = []
  static values = {
    generateUrl: String
  }

  connect() {
    this.confirmed = false;
    this.calculateTotalPoint()
  }

  changeFeeItem() {
    this.calculateTotalPoint()
  }

  // 請求項目ID（BillItem）。id=11(値引き)のみ合計から減算、それ以外は加算。
  // active_items から除外された項目はターゲットが描画されないため、
  // 実在するターゲットのみ集計する（未描画ターゲットの無条件参照による例外を防ぐ）。
  static FEE_ITEM_IDS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17]
  static DISCOUNT_ITEM_ID = 11

  calculateTotalPoint() {
    let total = 0
    this.constructor.FEE_ITEM_IDS.forEach((id) => {
      if (!this[`hasFee${id}Target`]) return
      const value = parseInt(this[`fee${id}Target`].value) || 0
      total += id === this.constructor.DISCOUNT_ITEM_ID ? -value : value
    })
    this.totalPointTarget.textContent = total
  }

  async generatePaymentLink() {
    const amount = parseInt(this.totalPointTarget.textContent) || 0
    if (amount <= 0) {
      this.showPaymentLinkError("合計金額が0円以下のため、リンクを生成できません")
      return
    }

    const button = this.generateButtonTarget
    button.classList.add('is-loading')
    button.disabled = true
    this.hidePaymentLinkError()

    try {
      const response = await fetch(this.generateUrlValue, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
        },
        body: JSON.stringify({ amount: amount })
      })
      const data = await response.json()

      if (response.ok) {
        this.paymentLinkTarget.value = data.url
        this.hidePaymentLinkError()
      } else {
        this.showPaymentLinkError(data.error || '決済リンクの生成に失敗しました')
      }
    } catch (e) {
      this.showPaymentLinkError('通信エラーが発生しました')
    } finally {
      button.classList.remove('is-loading')
      button.disabled = false
    }
  }

  showPaymentLinkError(message) {
    if (this.hasPaymentLinkErrorTarget) {
      this.paymentLinkErrorTarget.textContent = message
      this.paymentLinkErrorTarget.style.display = 'block'
    }
  }

  hidePaymentLinkError() {
    if (this.hasPaymentLinkErrorTarget) {
      this.paymentLinkErrorTarget.style.display = 'none'
    }
  }

  buttonDisabled(event){
    const el = event.currentTarget;
    el.disabled = true;
    if (el.name == "save_and_billed_button"){
      this.confirmed = true;
      const sab = document.getElementById("save_and_billed");
      sab.disabled = false;
    }
    if (el.name == "save_and_sales_confirmed_button"){
      const sab = document.getElementById("save_and_sales_confirmed");
      sab.disabled = false;
    }
    if (el.name == "save_and_calculate_waiting_button"){
      const sab = document.getElementById("save_and_calculate_waiting");
      sab.disabled = false;
    }
    const payment_link_required = document.getElementById("payment_link_required");
    if (payment_link_required.value == "true"){
      const payment_link = document.getElementById("payment_link");
      if(payment_link.value == "" || payment_link.value == null){
        this.showPaymentLinkError("決済リンクを入力してください")
        this.confirmed = false;
      }else{
        this.hidePaymentLinkError()
        this.confirmed = true;
      }
    }
    if (this.confirmed == true){
      this.formTarget.submit();
    }else{
      el.disabled = false;
    }
  }

  confirmDialog(event){
    const params = event.params;
    const confirmed = confirm(params.confirm);
    if (!confirmed){
      event.preventDefault();
    }else{
      this.confirmed = true;
    }
  }
}
